"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/design-system/components/ui/tooltip";
import { Info } from "lucide-react";
import type { ReactNode } from "react";
interface InfoIconProps {
  children?: ReactNode;
}
export function InfoIcon(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TooltipTrigger asChild={true}><Info className="size-4 fill-currentColor" /></TooltipTrigger>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = children && <TooltipContent className="max-w-xs rounded-lg text-sm shadow-2xl" side="top" sideOffset={4}>{children}</TooltipContent>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Tooltip>{t1}{t2}</Tooltip>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}